<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" v-if="isAdmin">
          <card>
            <h4 slot="header" class="card-title">Report Data</h4>

            <div class="row">
              <div class="col-md-3">
                <base-input
                  type="date"
                  label="Date"
                  placeholder="Date"
                  v-model="report.rDate"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  type="text"
                  label="Code"
                  placeholder="Code"
                  v-model="report.rCode"
                ></base-input>
              </div>
              <div class="col-md-3">
                <label class="form-label">Type</label>
                <select
                  class="form-control"
                  v-model="report.rType"
                  @change="onTypeChange"
                >
                  <option value="">Select Type</option>
                  <option
                    v-for="type in reportTypes"
                    :key="type.id"
                    :value="type.type_name"
                  >
                    {{ type.type_name }}
                  </option>
                  <option value="__new__">+ Add New Type</option>
                </select>
                <input
                  v-if="showCustomTypeInput"
                  type="text"
                  class="form-control mt-2"
                  placeholder="Enter new type"
                  v-model="customType"
                  @blur="addCustomType"
                  @keyup.enter="addCustomType"
                />
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  label="In"
                  placeholder="In"
                  v-model="report.rIn"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  label="Out"
                  placeholder="Out"
                  v-model="report.rOut"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="text"
                  readonly
                  label="Balance"
                  placeholder="Balance"
                  v-model="balance"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  label="Partner %"
                  placeholder="Partner %"
                  v-model="report.partnerPercent"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="text"
                  readonly
                  label="Partner"
                  placeholder="Partner"
                  v-model="partnerComm"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  type="text"
                  label="Remark"
                  placeholder="Remark"
                  v-model="report.remark"
                ></base-input>
              </div>
            </div>
            <div class="text-right">
              <button
                v-if="report.id"
                @click="cancelEdit"
                class="btn mr-3 btn-secondary btn-fill btn-sm"
              >
                Cancel
              </button>
              <button
                v-if="editIndex == -1"
                class="btn btn-primary btn-fill btn-sm"
                @click="addNewData"
              >
                Save
              </button>
              <button
                v-if="editIndex !== -1"
                class="btn btn-primary btn-fill btn-sm"
                @click="saveUser(editIndex)"
              >
                Update
              </button>
            </div>
          </card>
        </div>
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h4 class="card-title">Report List</h4>
                  <div class="mt-2">
                    <h5 class="text-muted">
                      Total Records: {{ dataList.length }} |
                      <strong>OVERALL TOTALS</strong> - In:
                      <strong>{{
                        formatCurrency(overallTotal.totalIn)
                      }}</strong>
                      | Out:
                      <strong>{{
                        formatCurrency(overallTotal.totalOut)
                      }}</strong>
                      | Balance:
                      <strong>{{
                        formatCurrency(overallTotal.totalBalance)
                      }}</strong>
                      | Partner Comm:
                      <strong>{{
                        formatCurrency(overallTotal.totalPartnerComm)
                      }}</strong>
                    </h5>
                  </div>
                </div>
              </div>
            </template>

            <template>
              <div class="card-body">
                <!-- Filter Section -->
                <div class="col-12">
                  <card>
                    <h5 slot="header" class="card-title">Filters</h5>
                    <div class="row">
                      <div class="col-md-3">
                        <base-input
                          type="date"
                          label="Start Date"
                          v-model="filters.startDate"
                        ></base-input>
                      </div>
                      <div class="col-md-3">
                        <base-input
                          type="date"
                          label="End Date"
                          v-model="filters.endDate"
                        ></base-input>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">Filter by Type</label>
                        <!-- <select
                          class="form-control"
                          v-model="filters.reportType"
                        >
                          <option value="">All Types</option>
                          <option
                            v-for="type in reportTypes"
                            :key="type.id"
                            :value="type.type_name"
                          >
                            {{ type.type_name }}
                          </option>
                        </select> -->
                        <multiselect
                          v-model="filters.reportTypes"
                          :options="reportTypes"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select types"
                          label="type_name"
                          track-by="id"
                          :preselect-first="false"
                        >
                          <template
                            slot="selection"
                            slot-scope="{ values, isOpen }"
                          >
                            <span
                              class="multiselect__single"
                              v-if="values.length && !isOpen"
                            >
                              {{ values.length }} type(s) selected
                            </span>
                          </template>
                        </multiselect>
                      </div>
                      <div class="col-md-3">
                        <base-input
                          type="text"
                          label="Code/Remark"
                          placeholder="Enter Code/Remark"
                          v-model="filters.codeRemark"
                        ></base-input>
                      </div>
                      <div class="col-md-3 d-flex align-items-end">
                        <button
                          class="btn btn-info btn-fill btn-sm mr-2"
                          @click="applyFilters"
                        >
                          Apply Filters
                        </button>
                        <button
                          class="btn btn-secondary btn-fill btn-sm"
                          @click="clearFilters"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </card>
                </div>
                <table id="myTable" class="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th v-for="column in tableColumns" :key="column">
                        {{ column }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in dataList">
                      <td>{{ row.id }}</td>
                      <td>{{ row.rDate }}</td>
                      <td>{{ row.rCode }}</td>
                      <td>{{ row.rType }}</td>
                      <td>{{ row.rIn }}</td>
                      <td>{{ row.rOut }}</td>
                      <td>{{ row.balance }}</td>
                      <td>{{ row.partnerPercent }}</td>
                      <td>{{ row.partnerComm }}</td>
                      <td>{{ row.remark }}</td>
                      <td v-if="isAdmin">
                        <button
                          @click="editUser(index, row)"
                          class="btn btn-primary btn-sm"
                        >
                          Edit
                        </button>
                        <button
                          @click="deleteUser(row.id)"
                          class="btn btn-danger btn-sm"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="dataList.length > 0">
                    <tr class="table-info font-weight-bold">
                      <td colspan="4" class="text-right">
                        <strong>PAGE TOTALS:</strong>
                      </td>
                      <td>
                        <strong>{{ formatCurrency(pageTotal.totalIn) }}</strong>
                      </td>
                      <td>
                        <strong>{{
                          formatCurrency(pageTotal.totalOut)
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{
                          formatCurrency(pageTotal.totalBalance)
                        }}</strong>
                      </td>
                      <td></td>
                      <!-- % column -->
                      <td>
                        <strong>{{
                          formatCurrency(pageTotal.totalPartnerComm)
                        }}</strong>
                      </td>
                      <td></td>
                      <!-- Remark column -->
                      <td v-if="isAdmin"></td>
                      <!-- Action column -->
                    </tr>
                  </tfoot>
                </table>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card.vue";
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { fetchReportList, fetchReportListWithFilters } from "src/utils/api";

export default {
  components: {
    Card,
    Multiselect,
  },
  data() {
    return {
      editIndex: -1,
      editItem: {},
      selectedUsers: [],
      selectAll: false,
      showCustomTypeInput: false,
      customType: "",
      reportTypes: [],
      filters: {
        startDate: "",
        endDate: "",
        reportTypes: [],
        codeRemark: "",
      },
      report: {
        rDate: "",
        rCode: "",
        rType: "",
        rIn: "",
        rOut: "",
        partnerPercent: "",
        remark: "",
      },
      // tableColumns: ['Id', 'Date', 'Code', 'In', 'Out', '%', 'Partner', 'Total', 'Remark', 'Action'],
      dataList: [],
      pageTotal: {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
        totalPartnerComm: 0,
      },
      overallTotal: {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
        totalPartnerComm: 0,
      },
    };
  },
  watch: {
    // selectedUsers(val) {
    //     if (this.selectedUsers.length === this.dataList.length) {
    //         this.selectAll = true
    //     } else this.selectAll = false
    // }
  },
  computed: {
    tableColumns() {
      if (this.isAdmin) {
        return [
          "Id",
          "Date",
          "Code",
          "Type",
          "In",
          "Out",
          "Balance",
          "%",
          "Partner",
          "Remark",
          "Action",
        ];
      } else {
        return [
          "Id",
          "Date",
          "Code",
          "Type",
          "In",
          "Out",
          "Balance",
          "%",
          "Partner",
          "Remark",
        ];
      }
    },
    balance() {
      return this.report.rIn - this.report.rOut;
    },
    partnerComm() {
      return (this.balance * this.report.partnerPercent) / 100;
    },
    isAdmin() {
      return localStorage.getItem("role") == "developer" ||
        localStorage.getItem("role") == "admin"
        ? true
        : false;
    },
  },
  methods: {
    formatCurrency(amount) {
      if (!amount && amount !== 0) return "0.00";
      return parseFloat(amount).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    calculateOverallTotals() {
      this.overallTotal = {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
        totalPartnerComm: 0,
      };

      // Calculate totals for ALL data (not just current page)
      this.dataList.forEach((rowData) => {
        const rIn = parseFloat(rowData.rIn || 0);
        const rOut = parseFloat(rowData.rOut || 0);
        const balance = parseFloat(rowData.balance || 0);
        const partnerComm = parseFloat(rowData.partnerComm || 0);

        this.overallTotal.totalIn += rIn;
        this.overallTotal.totalOut += rOut;
        this.overallTotal.totalBalance += balance;
        this.overallTotal.totalPartnerComm += partnerComm;
      });

      console.log("Overall Totals calculated:", this.overallTotal);
    },
    calculatePageTotals() {
      // Reset totals
      this.pageTotal = {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
        totalPartnerComm: 0,
      };

      // Get visible rows on current page
      if ($.fn.DataTable.isDataTable("#myTable")) {
        const table = $("#myTable").DataTable();

        // Get the indexes of visible rows on current page
        const visibleIndexes = table.rows({ page: "current" }).indexes();

        console.log("Visible indexes:", visibleIndexes.length); // Debug

        // Calculate totals for visible rows
        for (let i = 0; i < visibleIndexes.length; i++) {
          const rowIndex = visibleIndexes[i];
          const rowData = this.dataList[rowIndex];

          if (rowData) {
            console.log(rowData, "rowData");
            const rIn = parseFloat(rowData.rIn || 0);
            const rOut = parseFloat(rowData.rOut || 0);
            const balance = parseFloat(rowData.balance || 0);
            const partnerComm = parseFloat(rowData.partnerComm || 0);

            this.pageTotal.totalIn += rIn;
            this.pageTotal.totalOut += rOut;
            this.pageTotal.totalBalance += balance;
            this.pageTotal.totalPartnerComm += partnerComm;
          }
        }

        console.log("Page Totals calculated:", this.pageTotal); // Debug
      }
    },
    async loadReportTypes() {
      try {
        let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=getReportTypes`;
        const response = await axios.get(apiUrl);
        if (response.data.status === "success") {
          this.reportTypes = response.data.data;
        }
      } catch (error) {
        console.error("Error loading report types:", error);
      }
    },
    onTypeChange() {
      // If user selects a custom option or wants to add new type
      if (this.report.rType === "__new__") {
        this.showCustomTypeInput = true;
        this.customType = "";
        this.report.rType = "";

        // Focus on the input field after it's rendered
        this.$nextTick(() => {
          if (this.$refs.customTypeInput) {
            this.$refs.customTypeInput.focus();
          }
        });
      } else {
        this.showCustomTypeInput = false;
      }
    },

    handleCustomTypeBlur() {
      // If user leaves the input without entering anything, hide it
      if (!this.customType.trim()) {
        this.showCustomTypeInput = false;
      }
    },

    async addCustomType() {
      if (this.customType.trim()) {
        try {
          let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=addReportType`;
          const response = await axios.post(apiUrl, {
            type_name: this.customType.trim(),
          });

          if (response.data.status === "success") {
            this.report.rType = this.customType.trim();
            this.customType = "";
            this.showCustomTypeInput = false;
            await this.loadReportTypes(); // Refresh the types list
            alert(`Type "${this.report.rType}" added successfully!`);
          } else {
            alert("Error: " + response.data.message);
          }
        } catch (error) {
          console.error("Error adding custom type:", error);
          alert("Failed to add custom type: " + error.message);
        }
      }
    },
    applyFilters() {
      this.loadReportWithFilters();
    },
    clearFilters() {
      this.filters = {
        startDate: moment().subtract(7, "day").format("YYYY-MM-DD"),
        endDate: moment().add(1, "day").format("YYYY-MM-DD"),
        reportTypes: [],
        reportTypes: [],
      };
      this.loadReportWithFilters();
    },
    async loadReportWithFilters() {
      let self = this;
      this.dataList = [];
      if ($.fn.DataTable.isDataTable("#myTable")) {
        $("#myTable").DataTable().clear().destroy();
      }
      try {
        const data = await fetchReportListWithFilters(this.filters);
        data.forEach((item) => {
          item.balance = parseFloat(item.rIn || 0) - parseFloat(item.rOut || 0);
          item.partnerComm = (item.balance * item.partnerPercent) / 100;
        });

        this.dataList = [...data];
        this.calculateOverallTotals();
        console.log(this.dataList, "loadReportWithFilters");
        this.$nextTick(() => {
          // Base column definitions (always present)
          const baseColumnDefs = [
            { width: "5%", targets: 0 }, // Id
            { width: "10%", targets: 1 }, // Date
            { width: "10%", targets: 2 }, // Code
            { width: "8%", targets: 3 }, // Type
            { width: "10%", targets: 4 }, // In
            { width: "10%", targets: 5 }, // Out
            { width: "10%", targets: 6 }, // Balance
            { width: "5%", targets: 7 }, // %
            { width: "10%", targets: 8 }, // Partner
            { width: "12%", targets: 9 }, // Remark
          ];
          
          // Add Action column only for admin/developer
          const columnDefs = this.isAdmin
            ? [...baseColumnDefs, { width: "10%", targets: 10, orderable: false }] // Action column
            : baseColumnDefs;
          
          // Check if table exists before initializing DataTables
          const tableElement = document.querySelector("#myTable");
          if (!tableElement) {
            console.error("Table element #myTable not found");
            return;
          }
          
          $("#myTable").DataTable({
            pageLength: 10,
            lengthMenu: [10, 25, 50, 100],
            language: {
              lengthMenu: "Show _MENU_ entries",
            },
            // Add column width configuration
            order: [[1, "desc"]], // Column index 1 is Date, 'desc' for descending
            autoWidth: false,
            columnDefs: columnDefs,
            // Simple callback that runs after each draw
            drawCallback: function () {
              setTimeout(() => {
                self.calculatePageTotals();
              }, 50);
            },
          });

          // Initial calculation
          this.calculatePageTotals();
        });
      } catch (error) {
        alert(error.message);
      }
    },
    clearInput() {
      this.report = {
        rDate: "",
        rCode: "",
        rType: "",
        rIn: "",
        rOut: "",
        partnerPercent: "",
        remark: "",
      };
      this.showCustomTypeInput = false;
      this.customType = "";
    },
    addNewData() {
      if (this.report.rCode.trim() === "") {
        alert("Code cannot be empty");
        return;
      }
      if (confirm(`Are you sure to insert ${this.report.rCode}?`)) {
        let data = Object.assign({}, this.report);
        data.balance = this.balance;
        data.partnerComm = this.partnerComm;
        let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=createReport&type=report&platform=report`;
        axios
          .post(apiUrl, data)
          .then((response) => {
            if (response.data.status === "success") {
              alert(response.data.message);
              this.loadReportWithFilters();
              this.clearInput();
            } else {
              alert("Error: " + response.data.message);
            }
          })
          .catch((error) => {
            alert("Network Error: " + error);
          });
      }
    },
    saveUser(index) {
      if (confirm("Are you sure to update?")) {
        let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=updateReportDetail&type=reportList&platform=report`;
        axios
          .post(apiUrl, this.report)
          .then((response) => {
            if (response.data.status === "success") {
              this.$set(this.dataList, index, this.report);
              this.cancelEdit();
              alert(response.data.message);
              this.loadReportWithFilters();
            } else {
              alert("Error: " + response.data.message);
            }
          })
          .catch((error) => {
            alert("Network Error: " + error);
          });
      }
    },
    editUser(index, item) {
      this.editIndex = index;
      //   this.report = {
      //     ...item,
      //   };
      this.report = Object.assign({}, item);
    },
    cancelEdit() {
      this.editIndex = -1;
      this.editItem = {};
      this.clearInput();
    },
    deleteUser(id) {
      if (confirm("Are you sure to delete this list?")) {
        let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=reportList&platform=report`;
        axios
          .post(apiUrl, {
            id: id,
          })
          .then((response) => {
            if (response.data.status === "success") {
              alert(response.data.message);
              this.loadReportWithFilters();
            } else {
              alert("Error: " + response.data.message);
            }
          })
          .catch((error) => {
            alert("Network Error: " + error);
          });
      }
    },
  },
  async mounted() {
    this.filters.startDate = moment().subtract(7, "day").format("YYYY-MM-DD");
    this.filters.endDate = moment().add(1, "day").format("YYYY-MM-DD");

    await this.loadReportTypes();
    this.loadReportWithFilters();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.table-scroll-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.table {
  min-width: 1000px;
  width: 100% !important;
}

/* Add specific styles for table cells */
#myTable td,
#myTable th {
  white-space: nowrap;
  padding: 8px 12px;
}

/* Make remark column wrap text if needed */
#myTable td:nth-child(10) {
  white-space: normal;
  word-wrap: break-word;
}

/* Ensure footer cells align properly */
.table tfoot td {
  font-weight: bold;
  background-color: #d1ecf1 !important;
}

.table-info {
  background-color: #d1ecf1 !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

/* Ensure action buttons don't wrap */
#myTable td:last-child {
  white-space: nowrap;
}

#myTable td:last-child button {
  margin-right: 5px;
  margin-bottom: 5px;
}

/* Multiselect custom styling */
.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 40px 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multiselect__select {
  height: 38px;
}

.multiselect__placeholder {
  margin-bottom: 8px;
  padding-top: 0px;
  color: #999;
}
</style>
